import React, { useState, useEffect } from "react";
import axios from "axios";
import { 
  BiWallet, BiPlusCircle, BiHistory, BiArrowBack, 
  BiTrendingUp, BiTrendingDown, BiX, BiShieldQuarter 
} from "react-icons/bi";
import { baseurl } from "../../baseurl";
import "../../asset/css/wallet.css";
import { HiOutlineUser, HiOutlineWallet, HiOutlineTicket, HiOutlineSparkles } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Wallet = () => {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addAmount, setAddAmount] = useState("");
  const [processing, setProcessing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  const guestUserId = localStorage.getItem("guestUserId");

  const fetchWalletData = async () => {
    try {
      const [balanceRes, historyRes] = await Promise.all([
        axios.get(`${baseurl}/getWalletBalance/${guestUserId}`),
        axios.get(`${baseurl}/getWalletHistory/${guestUserId}`)
      ]);
      setBalance(balanceRes.data.balance || 0);
      setTransactions(historyRes.data.transactions || []);
    } catch (err) { console.error(err); } 
    finally { setLoading(false); }
  };

  useEffect(() => { if (guestUserId) fetchWalletData(); }, [guestUserId]);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleAddMoney = async () => {
  if (!addAmount || addAmount < 10) return alert("Minimum recharge is ₹10");
  
  setProcessing(true);
  const scriptLoaded = await loadRazorpayScript();

  if (!scriptLoaded) {
    alert("SDK failed to load.");
    setProcessing(false);
    return;
  }

  // --- SERVICE CHARGE CALCULATION ---
  const SERVICE_CHARGE_PERCENT = 0.027; // 2.7%
  const baseAmount = parseFloat(addAmount);
  
  // Calculate and round off the service charge
  const serviceCharge = Math.round(baseAmount * SERVICE_CHARGE_PERCENT);
  
  // Final total amount to be paid (Base + Rounded Fee)
  const totalPayableAmount = baseAmount + serviceCharge;

  try {
    const orderRes = await axios.post(`${baseurl}/createWalletOrderUserGuest`, {
      amount: totalPayableAmount, // We send the total amount including the fee
      guest_id: guestUserId,
      baseAmount: baseAmount,    // Optional: send base amount for your records
      serviceCharge: serviceCharge // Optional: send fee amount for your records
    });

    if (orderRes.data.status === "success") {
      const options = {
        key: "rzp_live_bb0TqJFLwrGXrs",
        amount: orderRes.data.amount, // This is already in paise from backend
        currency: orderRes.data.currency,
        name: "TopAirView",
        description: `Wallet Top-up (Incl. ₹${serviceCharge} service charge)`,
        order_id: orderRes.data.order_id,
        handler: async (response) => {
          try {
            await axios.post(`${baseurl}/verifyWalletPaymentUserGuest`, {
              guest_id: guestUserId,
              amount: baseAmount, // The actual amount to be added to wallet balance
              totalPaid: totalPayableAmount, // The total money taken from user
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            
            setShowModal(false);
            setAddAmount("");
            fetchWalletData();
          } catch (verifyErr) {
            alert("Verification failed, please contact support.");
          }
        },
        theme: { color: "#166070" },
        modal: {
          ondismiss: () => setProcessing(false)
        }
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    }
  } catch (err) { 
    alert("Payment initiation failed."); 
  } finally { 
    setProcessing(false); 
  }
};

const navigate = useNavigate();
  const handleLogout = () => { 
  localStorage.clear(); 
  navigate("/"); 
  window.location.reload(); 
  };


  if (loading) return <div className="loader-container"><div className="spinner-border text-teal"></div></div>;

  return (
    <section className="wallet-page py-5">
      <div className="container">






        <div className="mobile-nav-wrapper mb-3">
  <div className="mobile-nav-container">
    <Link to="/profile" className="mobile-nav-link">
      <HiOutlineUser className="nav-icon" />
      <span>Profile</span>
    </Link>
    <Link to="/wallet" className="mobile-nav-link">
      <HiOutlineWallet className="nav-icon" />
      <span>Pocket</span>
    </Link>
    <Link to="/booking" className="mobile-nav-link">
      <HiOutlineTicket className="nav-icon" />
      <span>Bookings</span>
    </Link>

    <Link  className="mobile-nav-link" onClick={handleLogout}>
          <HiOutlineSparkles className="nav-icon" />
          <span>Logout</span>
        </Link>

    {/* Add more links here to see the sliding effect */}
    {/* <Link to="/settings" className="mobile-nav-link">
      <HiOutlineSparkles className="nav-icon" />
      <span>Settings</span>
    </Link> */}
  </div>
</div>
<style>
  {`
  /* Hide wrapper on Desktop */
.mobile-nav-wrapper {
  display: none;
}

@media (max-width: 768px) {
  .mobile-nav-wrapper {
    display: block;
    width: 100%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px); /* Glassmorphism effect */
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .mobile-nav-container {
    display: flex;
    overflow-x: auto; /* Enables sliding */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding: 12px 10px;
    gap: 15px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .mobile-nav-container::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .mobile-nav-container {
    -ms-overflow-style: none;  
    scrollbar-width: none;  
  }

  .mobile-nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 80px; /* Ensures enough width for sliding */
    text-decoration: none;
    color: #64748b; /* Slate gray */
    transition: all 0.3s ease;
    flex-shrink: 0; /* Prevents links from squishing */
  }

  .nav-icon {
    font-size: 20px;
    margin-bottom: 4px;
    padding: 0px;
    background: #f1f5f9;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .mobile-nav-link span {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /* Active/Hover State */
  .mobile-nav-link:hover, .mobile-nav-link:focus {
    color: #166070;
  }

  .mobile-nav-link:hover .nav-icon {
    background: #166070;
    color: #ffffff;
    transform: translateY(-2px);
  }
}
`}
</style>





        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div className="d-flex align-items-center">
            <button className="back-btn me-3" onClick={() => window.history.back()}>
              <BiArrowBack />
            </button>
            <h3 className="fw-bold m-0 text-dark">My Digital Pocket</h3>
          </div>
          <div className="security-badge d-none d-md-flex">
            <BiShieldQuarter className="me-2" /> 256-bit Secure
          </div>
        </div>

        <div className="row g-4">
          {/* Hero Balance Card */}
          <div className="col-lg-5">
            <div className="premium-card p-4 shadow-lg mb-4">
              <div className="d-flex justify-content-between align-items-start mb-4">
                <div>
                  <p className="text-white-50 small mb-1 uppercase tracking-wider">Total Balance</p>
                  <h1 className="display-5 fw-bold text-white mb-0">
                    ₹{parseFloat(balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </h1>
                </div>
                <div className="wallet-chip"></div>
              </div>
              
              <div className="card-footer-info d-flex justify-content-between align-items-center mt-5">
                <span className="text-white-50 small">Guest ID: #{guestUserId}</span>
                <button className="add-money-trigger" onClick={() => setShowModal(true)}>
                  <BiPlusCircle className="me-2" /> Add Funds
                </button>
              </div>
            </div>

            <div className="quick-stats p-3 bg-white rounded-4 shadow-sm">
               <div className="small text-muted mb-2">Pocket Insights</div>
               <div className="d-flex justify-content-between">
                  <div className="stat-item">
                    <BiTrendingUp className="text-success" />
                    <span className="ms-1 small">Monthly In: ₹0.00</span>
                  </div>
                  <div className="stat-item border-start ps-3">
                    <BiTrendingDown className="text-danger" />
                    <span className="ms-1 small">Monthly Out: ₹0.00</span>
                  </div>
               </div>
            </div>
          </div>

          {/* Transactions List */}
          <div className="col-lg-7">
            <div className="transaction-container p-4 bg-white rounded-4 shadow-sm">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 className="fw-bold m-0">Recent Activity</h5>
                <BiHistory className="text-muted" size={20} />
              </div>

              <div className="tx-scroll-area" style={{maxHeight: "100vh", overflow: "auto"}}>
                {transactions.length === 0 ? (
                  <div className="empty-state py-5 text-center">
                    <BiWallet size={50} className="text-light mb-3" />
                    <p className="text-muted">No transactions yet.</p>
                  </div>
                ) : (
                  transactions.map((tx) => (
                    <div className="tx-item d-flex align-items-center p-3 mb-2 rounded-3" key={tx.id}>
                      <div className={`tx-icon-box me-3 ${tx.type === 'credit' ? 'credit' : 'debit'}`}>
                        {tx.type === 'credit' ? <BiTrendingUp /> : <BiTrendingDown />}
                      </div>
                      <div className="flex-grow-1">
                        <p className="fw-bold mb-0 small text-dark">{tx.description}</p>
                        <p className="tx-date mb-0">{new Date(tx.created_at).toLocaleDateString()}</p>
                      </div>
                      <div className="text-end">
                        <p className={`fw-bold mb-0 ${tx.type === 'credit' ? 'text-success' : 'text-danger'}`}>
                          {tx.type === 'credit' ? '+' : '-'} ₹{tx.amount}
                        </p>
                        <span className={`status-pill ${tx.status}`}>{tx.status}</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modern Add Money Modal */}
      {showModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal-content p-4 shadow-lg">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="fw-bold m-0">Add Money</h5>
        <button className="close-btn" onClick={() => setShowModal(false)}>
          <BiX size={24} />
        </button>
      </div>
      
      <label className="small text-muted mb-2">Enter Amount</label>
      <div className="amount-input-container mb-4">
        <span className="currency-symbol">₹</span>
        <input 
          type="number" 
          autoFocus
          value={addAmount} 
          onChange={(e) => setAddAmount(e.target.value)}
          placeholder="0.00"
        />
      </div>

      <div className="quick-select gap-2 mb-4">
        {[500, 1000, 2000, 5000].map(amt => (
          <button key={amt} className="amt-chip" onClick={() => setAddAmount(amt)}>
            ₹{amt}
          </button>
        ))}
      </div>

      {/* --- PRICE BREAKDOWN SECTION --- */}
      {addAmount >= 10 && (
        <div className="bg-light p-3 rounded-3 mb-4">
          <div className="d-flex justify-content-between small text-muted mb-1">
            <span>Recharge Amount</span>
            <span>₹{parseFloat(addAmount).toLocaleString()}</span>
          </div>
          <div className="d-flex justify-content-between small text-muted mb-2">
            <span>Service Charge (2.7%)</span>
            <span>+ ₹{Math.round(addAmount * 0.027)}</span>
          </div>
          <div className="d-flex justify-content-between fw-bold border-top pt-2 text-dark">
            <span>Total Payable</span>
            <span className="text-primary">₹{Math.round(addAmount * 1.027)}</span>
          </div>
        </div>
      )}

      <button 
        className="recharge-btn w-100 py-3 rounded-3 fw-bold" 
        onClick={handleAddMoney}
        disabled={processing || !addAmount || addAmount < 10}
      >
        {processing 
          ? "Connecting to Gateway..." 
          : `Pay ₹${addAmount >= 10 ? Math.round(addAmount * 1.027) : addAmount}`
        }
      </button>
      
      <p className="text-center small text-muted mt-3 mb-0">
        <FaShieldAlt className="me-1" /> Secure Encrypted Payment
      </p>
    </div>
  </div>
)}
    </section>
  );
};

export default Wallet;